//import components
import mainnav from '@/components/_globals/mainnav/mainnav.vue'


export default {
  name: 'services',
  data () {
    return {
      scrolled: false,
      parallax1: 'services-content-01.jpg',
      parallax3: 'services-content-03.jpg'
    }
  },
  components: {
    mainnav
  },
  computed: {
    currentLocale: function () {
      return this.$i18n.locale
    }
  },
  methods: {
    handleScroll (event) {
      this.scrolled = true
      var fullwidth = $(window).width();

      var scrollBottom = event.currentTarget.scrollTop + $(window).height();

      if (event.currentTarget.scrollTop > 0) {
        $(".animation").css("left", event.currentTarget.scrollTop + 'px');
      } else {
          $(".animation").css("left", '0px');
      }
    }

  },
  created () {
    //window.addEventListener('scroll', this.handleScroll);
    //document.body.addEventListener('scroll', this.handleScroll);
  },
  destroyed () {
    //window.removeEventListener('scroll', this.handleScroll);
    //document.body.addEventListener('scroll', this.handleScroll);
  }
}


// WEBPACK FOOTER //
// ./src/components/services/services.js